<template>
  <div>
    <div class="d-flex justify-content-between p-2">
      <div>
        <el-button type="default" @click="$router.back()">
          <i class="el-icon-back" />
          <span v-t="'general.back'" />
        </el-button>
      </div>
    </div>
    <div class="p-3">
      <OrderRequestOverviewEntry
        v-for="item in items"
        :key="item.id"
        class="mt-3 cursor-pointer"
        :item="item"
        @click.native="onSelect(item)"
      />
    </div>
  </div>
</template>

<script>
import OrderRequestOverviewEntry from './components/OrderRequestOverviewEntry';
export default {
  name: 'AllCartOrdersRequestsView',
  components: { OrderRequestOverviewEntry },
  props: {},
  async mounted() {
    let query = new this.$parse.Query(this.checkoutType);
    query.equalTo('user', this.$parse.User.current());
    query.addAscending('createdAt');
    query.include('deliveryAddress');
    this.items = await query.find();
  },
  destroyed() {},
  data() {
    return {
      items: [],
    };
  },
  computed: {
    checkoutType() {
      return this.$route.params.checkoutType;
    },
    routeName() {
      return this.checkoutType === 'CartRequest'
        ? this.$routeNames.REQUEST_DETAIL_PAGE_ROUTE
        : this.$routeNames.ORDER_DETAIL_PAGE_ROUTE;
    },
  },
  methods: {
    onSelect(item) {
      this.$router.push({ name: this.routeName, params: { id: item.id } });
    },
  },
};
</script>

<style scoped></style>
